import React from "react";
import { useHotelDynamicDetails } from "../../context";
import StayDates from "src/Modules/Hotels/Components/StayDates/StayDates";
import HotelIdentityInfo from "src/Modules/Hotels/Components/HotelIdentityInfo/HotelIdentityInfo";

export const HotelDetailsOverview: React.FC = () => {
  const { hotel, searchObject, numberOfNights } = useHotelDynamicDetails();
  const heroImage = hotel.image ?? hotel.images?.[0] ?? null;

  return (
    <div className="border-border-active flex h-full w-full flex-col gap-3 rounded-xl border-s-4 bg-background-default p-4 md:gap-5">
      <div className="flex w-full items-start gap-3 md:gap-7">
        <div className="h-28.5 w-28.5 bg-background-minimal relative shrink-0 rounded-lg">
          {heroImage && (
            <img
              alt={hotel.hotelName}
              className="pointer-events-none absolute inset-0 h-full w-full rounded-lg object-cover"
              src={heroImage}
            />
          )}
        </div>
        <div className="flex min-w-px flex-1 flex-col justify-center gap-3">
          <HotelIdentityInfo
            hotelName={hotel.hotelName}
            hotelRating={hotel.hotelRating}
            address={hotel.address}
            variant="compact"
          />
        </div>
      </div>
      <StayDates
        checkin={searchObject?.checkin}
        checkout={searchObject?.checkout}
        numberOfNights={numberOfNights}
        variant="compact"
      />
    </div>
  );
};